// extracted by mini-css-extract-plugin
export default {"table":"List_table__RKlHO"};